<style lang="scss" type="stylesheet/scss" scoped>
@import '@/assets/var.scss';
.switch-cate {
  margin-top: 22px;
  .switch-tabs {
    border-bottom: solid 1px #eff0f4;
    .switch-tab {
      font-size: 14px;
      padding: 20px 10px;
      display: inline-block;
      margin: 0 20px;
      cursor: pointer;

      &.active {
        color: $mainBlue;
        position: relative;
        font-weight: bold;
        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 10px;
          right: 10px;
          background: $mainBlue;
          height: 4px;
        }
      }

      &:first-child {
        padding-left: 0;
        margin-left: 0;
        &.active {
          &:after {
            left: 0;
          }
        }
      }
    }
  }
}
.switch-body {
  border: solid 1px #eeeeee;
  height: 340px;
  margin-top: 22px;
  .el-col {
    height: 340px;
    overflow: auto;
    padding: 10px 0;
    border-right: solid 1px #eee;
  }
  .category-item {
    padding: 0 20px;
    line-height: 36px;
    font-size: 14px;
    cursor: pointer;
    position: relative;
    &.active {
      color: $mainBlue;
      background: #eeeeee;
      .el-icon-arrow-right {
        color: $mainBlue;
      }
      &:before {
        content: '';
        left: 0;
        top: 0;
        bottom: 0;
        width: 2px;
        background: $mainBlue;
        position: absolute;
      }
    }
    &:hover {
      color: $mainBlue;
      background: mix(#eeeeee, white, 40%);
      .el-icon-arrow-right {
        color: $mainBlue;
      }
    }
    .el-icon-arrow-right {
      float: right;
      line-height: 36px;
      font-weight: bold;
      color: #999;
    }
  }
}

.current-category {
  border: solid 1px #eee;
  padding: 22px;
  margin-top: 22px;
  .category-item {
    padding: 10px 0;
  }
}

.search-bar {
  .el-input,
  .el-select {
    margin-right: 20px;
    width: 240px;
  }
}
</style>

<template>
  <div class="switch-cate">

    <div class="search-bar">
      <el-input placeholder=输入类目目测快速搜索 clearable @keydown.native.enter="search"
        @input="search" v-model="keyword"></el-input>
      <!-- <el-select v-model="keyword"
                 filterable
                 placeholder="请输入关键词">
        <el-option v-for="item in filterData"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id">
        </el-option>
      </el-select> -->

      <el-button type="primary" @click="search">搜索</el-button>
    </div>

    <div class="switch-tabs">
      <div class="switch-tab" :class="{active:activeTab===0}"
        @click="activeTab=0,checkedCurrentCate=null,activeParentIndex=null,activeChildrenIndex=null,activeSonIndex=null">
        选择类目</div>
      <div class="switch-tab" :class="{active:activeTab===1}"
        @click="activeTab=1,checkedCurrentCate=null,activeParentIndex=null,activeChildrenIndex=null,activeSonIndex=null">
        常用类目</div>
    </div>

    <el-row class="switch-body" v-if="activeTab===0">
      <el-col :span="8">
        <div style="font-size:14px;line-height:4;color:#999;text-align:center"
          v-if="!filterData.filter(e=>e.show).length">暂无</div>
        <div class="parent-category category-item"
          :class="{active:activeParentIndex === pIndex}"
          @click="activeParentIndex = pIndex,activeChildrenIndex = activeSonIndex = null"
          v-if="parentCate.show" v-for="(parentCate,pIndex) in filterData">
          <span class="label">{{parentCate.categoryName}}</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </el-col>
      <el-col :span="8" v-if="activeParentIndex!==null">
        <div class="children-category category-item"
          :class="{active:activeChildrenIndex === cIndex}"
          @click="activeChildrenIndex = cIndex,activeSonIndex = null"
          v-if="childCate.show"
          v-for="(childCate,cIndex) in filterData[activeParentIndex].childrenCategory">
          <span class="label">{{childCate.categoryName}}</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </el-col>
      <el-col :span="8" v-if="activeChildrenIndex!==null">
        <div class="children-category category-item"
          :class="{active:activeSonIndex === sIndex}"
          @click="activeSonIndex = sIndex" v-if="son.show"
          v-for="(son,sIndex) in filterData[activeParentIndex].childrenCategory[activeChildrenIndex].childrenCategory">
          <span class="label">{{son.categoryName}}</span>
          <!-- <i class="el-icon-arrow-right"></i> -->
        </div>
      </el-col>
    </el-row>

    <div class="current-category" v-if="activeTab === 1">
      <div style="text-align:center;color:#999;line-height:2;margin-top:22px"
        v-if="!recentCategortList.length">
        暂无常用类目</div>
      <el-radio-group v-model="checkedCurrentCate">
        <div v-for="(cate,cateIndex) in recentCategortList"
          class="category-item">
          <el-radio :label="cate.categoryChild.id">
            {{cate.label}}</el-radio>
        </div>
      </el-radio-group>
    </div>

    <div style="margin-top:22px">
      <el-button @click="nextStep"
        :disabled="!(activeSonIndex === 0 || activeSonIndex > 0) && !checkedCurrentCate"
        type="primary">下一步</el-button>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'switch-cate',
  data() {
    return {
      keyword: '',
      activeTab: 0,
      rawData: [],
      activeParentIndex: null,
      activeChildrenIndex: null,
      activeSonIndex: null,
      checkedCurrentCate: null,
      recentCategortList: [],
      filterData: [],
    };
  },
  created() {
    this.getTableData();
    this.getCurrentCategort();
  },
  methods: {
    async getCurrentCategort() {
      let res = await this.$axios.post({
        url: '/v1/sellerCenter/product/getSellerFrequentlyCategoryList',
      });

      this.recentCategortList = res.data.map((e) => {
        e = JSON.parse(e);
        e.label = `${e.categoryType === 0 ? '产品分类' : '施工分类'} > ${
          e.categoryName
        } > ${e.categoryChild.categoryName}`;

        return e;
      });
    },
    search() {
      this.activeParentIndex = null;
      this.activeChildrenIndex = null;
      this.activeSonIndex = null;

      const that = this;

      function setItemShow(list) {
        list.forEach((item) => {
          item.show = true;

          if (item.childrenCategory && item.childrenCategory.length) {
            setItemShow(item.childrenCategory);
          }
        });
      }

      (function findItemForList(list, call) {
        list.forEach((item) => {
          item.show = false;

          if (item.categoryName.includes(that.keyword)) {
            item.show = true;
            call && call();
            if (item.childrenCategory && item.childrenCategory.length) {
              setItemShow(item.childrenCategory);
            }
          } else if (item.childrenCategory && item.childrenCategory.length) {
            findItemForList(item.childrenCategory, () => {
              item.show = true;
              call && call();
            });
          }
        });
      })(this.filterData);

      // this.filterData.forEach((e) => {
      //   let tmpData = [];
      //   if (e.categoryName.includes(this.keyword)) {
      //     this.filterData.push(JSON.parse(JSON.stringify(e)));
      //   } else {
      //     let children = [];
      //     e.childrenCategory.forEach((f) => {
      //       if (f.categoryName.includes(this.keyword)) {
      //         children.push(f);
      //       }
      //     });
      //     if (children && children.length) {
      //       let obj = JSON.parse(JSON.stringify(e));
      //       obj.childrenCategory = children;
      //       this.filterData.push(obj);
      //     }
      //   }
      // });
    },
    nextStep() {
      console.log(this.checkedCurrentCate);
      this.$router.push({
        name: 'Publish-Product-Content',
        query: {
          cid: this.checkedCurrentCate
            ? this.checkedCurrentCate
            : this.rawData[this.activeParentIndex].childrenCategory[
                this.activeChildrenIndex
              ].childrenCategory[this.activeSonIndex].id,
        },
      });
    },
    async getTableData() {
      let data = await this.$store.dispatch('api/getCategory');
      let fixedData = [
        {
          categoryName: '产品分类',
          childrenCategory: data.filter((e) => e.categoryType === 0),
        },
        {
          categoryName: '施工分类',
          childrenCategory: data.filter((e) => e.categoryType === 1),
        },
      ];

      (function findItemForList(list) {
        list.forEach((item) => {
          item.show = true;

          if (item.childrenCategory && item.childrenCategory.length) {
            findItemForList(item.childrenCategory);
          }
        });
      })(fixedData);

      this.rawData = this.filterData = fixedData;
    },
  },
};
</script>
